import { useIntl } from "react-intl";
import dynamic from "next/dynamic";

import SEO from "../../components/SEO";
import Header from "../../components/Header";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";

import Variables from "../../variables/variables.json";
import Section from "../Section";

export default function DeklaracjaLayout(props) {
	const intl = useIntl();

	let Miasto = props.miasto;
	let Podatek = props.podatek;

	const CityDeklaracjaPL = dynamic(() =>
		import(
			"../../content/" +
				Variables.miasta[Miasto].name.url +
				"/deklaracja-dostepnosci/deklaracja-dostepnosci_pl.mdx"
		),
	);

	return (
		<>
			{/* HEAD */}
			<SEO
				miasto={Miasto}
				podatek={Podatek}
				noindex={Variables.miasta[Miasto].test}
				nofollow={Variables.miasta[Miasto].test}
			/>

			{/* TOP */}

			<Header miasto={Miasto} />

			<Breadcrumbs miasto={Miasto} layout="light" />

			{/* SECTION */}

			<Section mdx titleLeft>
				<CityDeklaracjaPL />
			</Section>

			{/* BOTTOM */}

			<Footer miasto={Miasto} />
		</>
	);
}
